import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import { Link, Redirect } from 'react-router-dom'
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import InvoiceStatusBadge from "../invoice/status.component.jsx";
import Pagination from "../common/listing/pagination.component.jsx";
import Icon from "../common/icon/icon.component.jsx";
import NewInvoiceModal from "../invoice/newmodal.component.jsx";
import ButtonWrapper from '../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component'
import GlobalHelper from '../common/GlobalHelper.jsx';

class RecurringInvoiceListByContact extends Component {

    constructor(props, context) {
        super(props, context)

        const contactId = this.props.contactId || ''
        this.state = {
            contactId: contactId,
            customerName: this.props.customerName || '',
            headers: [],
            rows: [],
            activePage: 1,
            pageSize: 10,
            totalItemsCount: 0,
            customerAccount: null,
            noEmployee: false,
            modal: '',
            contactType: '',
            accountLimit: null,
        }
        this.handlePageChange = this.handlePageChange.bind(this)
        this.handleCloseAndRefresh = this.handleCloseAndRefresh.bind(this)
        this.openInvoiceCreationModal = this.openInvoiceCreationModal.bind(this)
        this.refreshCustomerAccount = this.refreshCustomerAccount.bind(this)
        this.closeInvoiceCreationModal = this.closeInvoiceCreationModal.bind(this)
        this.refreshInvoiceList = this.refreshInvoiceList.bind(this)
    }

    componentDidMount() {
        AppContext.getApiClient().get('/account-limits').then(res => {
            this.setState({
                accountLimit: res,
            })
        })

        if (this.state.contactId) {
            this.refreshCustomerAccount(this.state.contactId)
        }
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            contactId: nextProps.contactId
        }, () => {
            this.loadInvoicesByContactId(this.state.contactId)
        })
    }
    
    refreshCustomerAccount(contactId) {
        
        AppContext.getApiClient().get('/customer-accounts/' + contactId).then(res => {
            if (res.error) {
                return
            }
            const noEmployee = res.attributes.contact.type === 'organizations' && !res.attributes.contact.attributes.primaryContactId
            this.setState({
                customerAccount: res,
                noEmployee: noEmployee,
                contactId: contactId,
                customerAccountIds: res.attributes.customerAccountIds || [],
                contactType: res.attributes.contactType || '',
            },()=> this.loadInvoicesByContactId(contactId))
        })
    }

    headers() {
        let headers = [
            <FormattedMessage
                id="customers.recurring_invoices.list.headers.id_label"
                defaultMessage="ID"
            />,
        ]
        if (this.state.contactType === 'organizations') {
            headers.push(<FormattedMessage
                id="customers.invoices.list.headers.employee_label"
                defaultMessage="Employee"
            />)
        }
        headers = headers.concat([
            <FormattedMessage
                id="customers.recurring_invoices.list.headers.next_due_date_label"
                defaultMessage="Next due date"
            />,
            <FormattedMessage
                id="customers.recurring_invoices.list.headers.status_label"
                defaultMessage="Status"
            />,
            <FormattedMessage
                id="customers.recurring_invoices.list.headers.amount_label"
                defaultMessage="Amount"
            />,
        ])
        return headers
    }

    row(invoice) {
        let rows = [
            <Link to={'/invoices/' + invoice.id + '/edit'}>
                {invoice.identifier}
            </Link>
        ]
        if (this.state.contactType === 'organizations') {
            rows.push(invoice.contact ?
                <Link className={invoice.contact.isArchived ? "text-danger" : ""} to={'/contacts/' + invoice.contactId + '/details'}>
                    {invoice.contact.name}
                </Link> : '-')
        }
        rows = rows.concat([
            <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(invoice.nextDueDate)}
            />,
            <InvoiceStatusBadge
                status={invoice.status}
            />,
            <FormattedNumber
                style="currency"
                currency={invoice.currency}
                value={invoice.totalAmount}
            />,
        ])
        return rows
    }

    loadInvoicesByContactId(contactId) {
        AppContext.getApiClient().get('/contacts/' + contactId).then(res => {
            if (res.error) {
                return
            }
            this.setState({
                noEmployee: res.type === 'organizations' && !res.attributes.primaryContactId,
                contactType: res.type
            })
            let postData = {
                keywords: '*',
                objects: ['invoices'],
                fields: ['identifier', 'contact.name'],
                pageSize: this.state.pageSize,
                activePage: this.state.activePage,
                sortByField: 'createdAt',
                sortAsc: true,
                filters: {
                    contactId: res.attributes.customerAccountIds,
                    billingType: 'recurring'
                },
                lightResult: true,
            }
            return AppContext.getApiClient().post('/listing/search', postData)
        }).then(r => {
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
                totalItemsCount: r.metadata.totalItemsCount,
            })
        })
    }

    refreshInvoiceList() {
        this.setState({
            activePage: 1,
        }, () => {
            this.loadInvoicesByContactId(this.state.contactId)
        })
    }

    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.loadInvoicesByContactId(this.state.contactId)
        })
    }

    handleCloseAndRefresh() {
        this.setState({
            modal: ''
        })
        this.loadInvoicesByContactId(this.state.contactId)
    }

    openInvoiceCreationModal(event) {
        event.preventDefault()

        let contactId= ""

        if(this.state.customerAccount?.attributes.contact?.type){
            switch (this.state.customerAccount.attributes.contactType) {
                case "organizations":
                        contactId = this.state.customerAccount.attributes.contact.attributes.primaryContactId
                    break
                case "persons":
                    contactId = this.state.contactId
                    break
                default:
                    return
            }
        }
    

        this.setState({
            modal: <NewInvoiceModal
                recurring={true}
                contactId={contactId || ""}
                onClose={this.closeInvoiceCreationModal}
            />
        })
    }

    closeInvoiceCreationModal(invoiceId) {
        this.setState({
            modal: invoiceId ? <Redirect to={'/invoices/' + invoiceId + '/edit'} /> : ''
        })
    }

    render() {
        if (this.state.rows.length < 0) {
            return <div />
        }
        return (
            <div>
                {this.state.modal}
                <StandardList
                    smallLine={true}
                    className="row pt-0"
                    headers={this.state.headers}
                    rows={this.state.rows}
                    footer={<div className="col-12 d-flex d-flex justify-content-between align-items-center">
                        <div>
                            <Pagination
                                className={'px-2'}
                                activePage={this.state.activePage}
                                pageSize={this.state.pageSize}
                                totalItemsCount={this.state.totalItemsCount}
                                onChange={this.handlePageChange}
                            />
                        </div>
                        {!this.state.noEmployee && this.state.accountLimit ? <div>
                            <ButtonWrapper
                                message={GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) ?
                                    <FormattedMessage
                                        id="listing.search.invoice_document_limit"
                                        defaultMessage="Documents limit exceeded."
                                    /> : ''}
                                onClick={(e) => this.openInvoiceCreationModal(e)}
                                className={"btn btn-primary btn-sm"}
                                protectedClassName={"btn btn-primary btn-sm"}
                                premium={false}
                                protectionRule={!GlobalHelper.isAccountLimitExceeded(this.state.accountLimit)}>
                                <Icon value={'plus-circle'} className={'mr-1'} />
                                <FormattedMessage
                                    id="customers.recurring_invoices.list.new_invoice_btn"
                                    defaultMessage="Create a new recurring invoice"
                                />
                            </ButtonWrapper>
                        </div> : null}
                    </div>}
                />
            </div>

        );
    }
}

export default RecurringInvoiceListByContact





// WEBPACK FOOTER //
// ./src/customer/recurringinvoicelist.component.jsx